import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";

import { LektoAuthService } from "../services/essential/lekto-auth.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  private readonly router = inject(Router);
  private readonly authService = inject(LektoAuthService);

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.isAuthenticated(route, state);
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.isAuthenticated(childRoute, state);
  }

  private async isAuthenticated(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (!this.authService.isLoggedIn()) {
      this.authService.login(state.url);
      return false;
    }

    const requiredRoles: string[] = route.data["profiles"];

    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }

    const hasAccess = this.authService.hasProfile(requiredRoles);

    if (!hasAccess) {
      await this.router.navigate(["/403"]);
      return false;
    }

    return true;
  }
}
